import { BlogPost } from "./blogUtils";
import matter from 'gray-matter';

// This function fetches blog posts from markdown files in the public/blog directory
export async function fetchBlogPosts(): Promise<BlogPost[]> {
  try {
    console.log("Fetching blog posts from markdown files");
    
    // List of blog post files - manually maintained or could be loaded from an index file
    const blogFiles = [
      'how-to-boost-productivity.md',
      'remote-work-tips.md',
      'ai-future-workflows.md',
      'pomodoro-technique.md',
      'daily-routine.md',
      'stop-procrastinating-techniques.md',
      'time-blocking.md'
    ];
    
    // Fetch all blog posts in parallel
    const posts = await Promise.all(
      blogFiles.map(async (filename) => {
        // Fetch the markdown file using the fetch API
        const response = await fetch(`/blog/${filename}`);
        const fileContents = await response.text();
        
        // Use gray-matter to parse the post metadata section
        const { data, content } = matter(fileContents);
        
        // Ensure the post has all required properties
        return {
          slug: data.slug,
          title: data.title,
          date: data.date,
          author: data.author,
          excerpt: data.excerpt,
          coverImage: data.coverImage,
          content: content
        } as BlogPost;
      })
    );
    
    console.log(`Found ${posts.length} blog posts from markdown files`);
    
    // Sort posts by date (newest first)
    return posts.sort((a, b) => {
      return new Date(b.date).getTime() - new Date(a.date).getTime();
    });
  } catch (error) {
    console.error("Error fetching blog posts:", error);
    return [];
  }
}
